import { render } from "./EmojisButton.vue?vue&type=template&id=408376f6&scoped=true"
import script from "./EmojisButton.vue?vue&type=script&lang=ts"
export * from "./EmojisButton.vue?vue&type=script&lang=ts"

import "./EmojisButton.vue?vue&type=style&index=0&id=408376f6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-408376f6"

export default script